<template>
  <div class="auth-wrapper auth-v2">
    <b-row
      class="auth-inner m-0"
      style="margin: 0 auto !important;"
    >
      <div class="main_block">
        <div class="header_block_div">
          <div class="reg_logo_section">
            <a
              class="brand-logo"
              @click="toAequitex()"
            >
              <img src="../../assets/images/logo/logo-green.png">
            </a>
          </div>
          <div class="reg-lang-section">
            <div
              class="register-languages-mobile small_screen_lang"
              align="end"
            >
              <b-dropdown
                id="dropdown-grouped"
                text="Dark"
                variant="outline-dark"
                class="dropdown-language no-border-button"
                right
              >
                <template #button-content>
                  <b-img
                    :src="currentLocale.img"
                    height="14px"
                    width="22px"
                    :alt="currentLocale.locale"
                  />
                  <span class="ml-50 text-body">{{ $t(currentLocale.name) }}</span>
                </template>
                <b-dropdown-item
                  v-for="localeObj in locales"
                  :key="localeObj.locale"
                  @click="$i18n.locale = localeObj.locale"
                >
                  <b-img
                    :src="localeObj.img"
                    height="14px"
                    width="22px"
                    :alt="localeObj.locale"
                  />
                  <span class="ml-50">{{ $t(localeObj.name) }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="reg-content-section">

          <b-col
            class="d-lg-flex align-items-center p-5 register_section_buttons"
            style="background-color:#F7F6F4; padding: 0 !important;"
          >
            <b-row class="col-md-12 flex-column align-items-start p-0">
              <div class="w-100 d-lg-flex align-items-center justify-content-center pl-5" >
                <b-img
                  fluid
                  style="width: 100%;"
                  :src="imgUrl"
                  alt="Login V2"
                />
              </div>
            </b-row>
          </b-col>

          <b-col
            class="row auth-bg px-1 p-0 pt-3" :md="5"
            style="background-color:#F7F6F4; margin: 0 auto"
          >
            <b-col
              sm="12"
              md="12"
              lg="12"
              v-if="!documentSigned"
              class="px-xl-2 mx-auto mt-2 skribble-container"
            >
              <h2 class="mb-2">{{ $t('proof_of_ownership') }}</h2>
              <div>
                <div v-if="$i18n.locale === 'de'">
                  <p>
                    Vielen Dank, dass Sie die Rechnung <strong>{{ invoice.invoice_number }}</strong>
                    der Firma <strong>{{ invoice.only_seller.name }}</strong> verifiziert und die Abtretung bewilligt haben.
                  </p>

                  <p>
                    Falls Sie einzelzeichnungsberechtigt sind, können Sie nun das Schuldanerkenntnis
                    in Bezug auf diese Rechnung uns gegenüber rechtsverbindlich abgeben. Hierzu
                    werden Sie im nächsten Schritt aufgefordert, das Dokument mittels qualifizierter
                    elektronischer Signatur (QES) zu unterzeichnen.
                    <em>(Die Registration, sowie die Abgabe der QES über unseren Provider Skribble
                      ist für Sie selbstverständlich kostenlos – hier können Sie sich registrieren.)</em>
                  </p>

                  <p>
                    Falls Sie per Handelsregister nicht oder nur kollektiv zu zweien zeichnungsberechtigt
                    sind, geben Sie bitte die erforderliche(n) zeichnungsberechtigte(n) Person(en) an:
                  </p>
                </div>
                <div v-else>
                  <p>
                    Thank you for verifying invoice <strong>{{ invoice.invoice_number }}</strong> from
                    <strong>{{ invoice.only_seller.name }}</strong> and approving the assignment.
                  </p>

                  <p>
                    If you are individually authorized to sign, you can now formally acknowledge the
                    debt arising from this invoice in our favor. In the next step, you will be asked
                    to sign the document using a Qualified Electronic Signature (QES).
                    <em>(Registration and the use of QES via our provider Skribble is, of course, free
                      of charge for you – you can register here.)</em>
                  </p>

                  <p>
                    If, according to the commercial register, you are not authorized to sign individually
                    or only jointly authorized to sign with another person, please provide the details
                    of the additionally required authorized signatory/signatories:
                  </p>
                </div>


                <b-row
                    m-0
                    p-0
                >
                  <b-col
                      cols="12"
                      xl="12"
                      md="12"
                      lg="12"
                  >
                    <b-form-group
                        id="signing-authority-type-group"
                        :label="$t('signatory_rights') + ':'"
                        label-for="signing-authority-type"
                        rules="required"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="signing-authority-type-group"
                          rules="required"
                      >
                        <b-input-group class="input-group-merge">
                          <b-input-group-prepend
                              is-text
                          >
                            <feather-icon
                                icon="UserPlusIcon"
                                class="cursor-pointer"
                            />
                          </b-input-group-prepend>
                          <b-form-select
                              id="signing-authority-type"
                              v-model.trim="signing_authority_type"
                              :disabled="isCompleted"
                              :options="[
                                { text: $t('select_one'), value: '', disabled: true},
                                { text: $t('no_signatory'), value: '2' },
                                { text: $t('sole_signatory'), value: '0' },
                                { text: $t('collectively_by_two'), value: '1' },
                              ]"
                              required
                              :state="errors.length > 0 ? false : null"
                          />
                        </b-input-group>
                      </validation-provider>
                      <small class="text-danger">{{ signing_authority_type_error }}</small>
                    </b-form-group>
                  </b-col>
                  <b-col
                      v-if="signing_authority_type == 2"
                      cols="12"
                      xl="12"
                      md="12"
                      lg="12"
                  >
                    <b-form-group
                        id="signing-authority-type-group"
                        :label="$t('how_many_signatures') + ':'"
                        label-for="signing-authority-type"
                        rules="required"
                    >
                      <b-form-select
                          v-model.trim="choose_signing_authority_type"
                          :disabled="isCompleted"
                          :options="[
                            {text: $t('select_one'), value: null, disabled: true},
                            {text: $t('one_signatory'), value: '1'},
                            {text: $t('two_signatories'), value: '2'},
                          ]"
                      />
                      <small class="text-danger">{{ choose_signing_authority_type_error }}</small>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col v-if="signing_authority_type == 2" :class="{'my-5': choose_signing_authority_type }">
                    <template v-if="choose_signing_authority_type == 1">
                      <!--No Signatory one signatories-->
                      <skribble-power-of-attorney-one-signatory :debtor-data="debtorData" :is-from-debtor="true" @internal-save="saveInternalData($event)"></skribble-power-of-attorney-one-signatory>
                    </template>
                    <template v-if="choose_signing_authority_type == 2">
                      <!--No Signatory two signatories-->
                      <skribble-power-of-attorney-two-signatories :debtor-data="debtorData" :is-from-debtor="true" @internal-save="saveInternalData($event)"></skribble-power-of-attorney-two-signatories>
                    </template>
                  </b-col>
                  <b-col class="my-5" v-if="signing_authority_type == 1">
                    <!--Collectively By Two-->
                    <skribble-power-of-attorney-collectively-by-two :debtor-data="debtorData" :is-from-debtor="true" @internal-save="saveInternalData($event)"></skribble-power-of-attorney-collectively-by-two>
                  </b-col>
                  <b-col class="my-1" v-if="signing_authority_type === '0'">
                    <!-- Sole Signatory -->
                    <div>
                      <div>
                        <!-- Manual debtor email input when user not found -->
                        <h4 class="mt-3 mb-1">{{ $t('skr_signatory_section') }}</h4>

                        <!-- Salutation / First / Last -->
                        <div class="form-row">
                          <div class="form-group col-4">
                            <label>{{ $t('skr_signatory_salutation') }} <span class="red-asterisk">*</span></label>
                            <validation-provider #default="{ errors }" name="sign_salutation" rules="required">
                              <select
                                  v-model="form.sign_salutation"
                                  class="form-control"
                                  :class="{ 'is-invalid': errors.length > 0 }"
                              >
                                <option value="" disabled>{{ $t('please_select') }}</option>
                                <option value="mr">{{ $t('mr') }}</option>
                                <option value="mrs">{{ $t('mrs') }}</option>
                              </select>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </div>

                          <div class="form-group col-4">
                            <label>{{ $t('first_name') }} <span class="red-asterisk">*</span></label>
                            <validation-provider #default="{ errors }" name="sign_first" rules="required">
                              <b-form-input
                                  v-model="form.sign_first"
                                  :class="{ 'is-invalid': invalidFields['sign_first'] }"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </div>

                          <div class="form-group col-4">
                            <label>{{ $t('last_name') }} <span class="red-asterisk">*</span></label>
                            <validation-provider #default="{ errors }" name="sign_last" rules="required">
                              <b-form-input
                                  v-model="form.sign_last"
                                  :class="{ 'is-invalid': invalidFields['sign_last'] }"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </div>
                        </div>

                        <!-- Address -->
                        <div class="form-row">
                          <div class="form-group col-12">
                            <label>{{ $t('skr_signatory_address') }} <span class="red-asterisk">*</span></label>
                            <validation-provider #default="{ errors }" name="sign_address" rules="required">
                              <b-form-input
                                  v-model="form.sign_address"
                                  :class="{ 'is-invalid': invalidFields['sign_address'] }"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </div>
                        </div>

                        <!-- ZIP / City / Country -->
                        <div class="form-row">
                          <div class="form-group col-4">
                            <label>{{ $t('skr_signatory_zip') }} <span class="red-asterisk">*</span></label>
                            <validation-provider #default="{ errors }" name="sign_zip" rules="required">
                              <b-form-input
                                  v-model="form.sign_zip"
                                  :class="{ 'is-invalid': invalidFields['sign_zip'] }"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </div>

                          <div class="form-group col-4">
                            <label>{{ $t('city') }} <span class="red-asterisk">*</span></label>
                            <validation-provider #default="{ errors }" name="sign_city" rules="required">
                              <b-form-input v-model="form.sign_city" :class="{ 'is-invalid': invalidFields['sign_city'] }"/>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </div>

                          <div class="form-group col-4">
                            <label>{{ $t('country_name') }} <span class="red-asterisk">*</span></label>
                            <validation-provider #default="{ errors }" name="sign_country" rules="required">
                              <select
                                  v-model="form.sign_country"
                                  class="form-control"
                                  :class="{ 'is-invalid': errors.length > 0 }"
                              >
                                <option value="" disabled>{{ $t('please_select') }} {{ $t('country_name') }}</option>
                                <option v-for="country in countryOptions" :key="country.id" :value="country.name">
                                  {{ country.name }}
                                </option>
                              </select>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </div>
                        </div>

                        <!-- Email and Mobile -->
                        <div class="form-row">
                          <b-form-group class="col-6 mb-2">
                            <label>{{ $t('skr_signatory_email') }} <span class="red-asterisk">*</span></label>
                            <validation-provider #default="{ errors }" name="debtor_email" rules="required|email">
                              <b-input-group class="input-group-merge">
                                <b-input-group-prepend is-text>
                                  <feather-icon icon="MailIcon" />
                                </b-input-group-prepend>
                                <b-form-input
                                    id="manual-debtor-email"
                                    v-model.trim="form.debtor_email"
                                    type="email"
                                    :class="{ 'is-invalid': invalidFields['debtor_email'] }"
                                    :disabled="loading"
                                />
                              </b-input-group>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>

                          <b-form-group class="col-6">
                            <label>{{ $t('mobile') }} <span class="red-asterisk">*</span></label>
                            <validation-provider
                                ref="phoneValidator"
                                #default="{ errors }"
                                name="phoneValidation"
                                rules="required"
                            >
                              <b-input-group>
                                <b-input-group-prepend id="phoneCountries">
                                  <b-form-select
                                      v-model.trim="form.sign_phone_code"
                                      :options="countries"
                                  />
                                </b-input-group-prepend>

                                <b-form-input
                                    id="sign-mobile-second"
                                    v-model.trim="form.sign_mobile"
                                    class="form-control"
                                    :state="errors.length > 0 ? false : null"
                                    :class="{ 'is-invalid': invalidFields['sign_mobile'] }"
                                    ref="sign_mobile"
                                    @input="checkPhoneFormat"
                                />
                              </b-input-group>

                              <small class="text-danger">{{ $t(errors[0]) }}</small>
                              <small
                                  v-if="phoneValidation"
                                  class="text-danger"
                              >{{ phoneValidation }}
                              </small>
                            </validation-provider>
                          </b-form-group >
                        </div>
                        <!-- Sole signatory button -->
                        <button
                            @click="generateGermanDebtAcknowledgement"
                            :disabled="loading"
                            class="btn btn-primary w-100"
                        >
                          <span v-if="loading">
                            <img width="50" height="50" src="/new-loader.svg" alt="loader"/>
                          </span>
                          <span v-else>
                            {{ $t('skr_btn_sole_signatory') }}
                          </span>
                        </button>

                        <SkribblePopup
                            :show="showPopup"
                            @cancel="showPopup = false"
                            @continue="handlePopupConfirm"
                        />
                      </div>

                      <div v-if="error" class="alert text-danger mt-1">{{ $t(error) }}</div>
                    </div>
                  </b-col>
                </b-row>

                <div>
                  <p class="mt-1 text-muted">
                    {{ $t('skr_muted_note') }}
                  </p>
                </div>
              </div>
            </b-col>
            <div v-else class="p-4 text-center col-12">
              <h2 class="text-success text-large">{{ $t('skr_document_signed') }}</h2>
            </div>
          </b-col>

          <b-col
            class="pb-5"
            style="background: rgb(247, 246, 244);"
          >
            <iframe
              width="100%"
              height="800px"
              src="https://support-aequitex.zohobookings.eu/portal-embed#/customer/167264000000318034"
              frameborder="0"
              allowfullscreen=""
            />
          </b-col>
        </div>
      </div>

      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton, BFormSelect, BInputGroupPrepend,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import axios from 'axios'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import snsWebSdk from '@sumsub/websdk'
import SkribblePowerOfAttorneyOneSignatory from "@/components/skribble/PowerOfAttorneyOneSignatory.vue";
import SkribblePowerOfAttorneyTwoSignatories from "@/components/skribble/PowerOfAttorneyTwoSignatories.vue";
import SkribblePowerOfAttorneyCollectivelyByTwo from "@/components/skribble/PowerOfAttorneyCollectivelyByTwo.vue";
import {CurrencyAmountFormat} from "@core/utils/CurrencyAmountFormat";
import {phone} from "phone";

export default {
  components: {
    BInputGroupPrepend,
    BFormSelect, SkribblePowerOfAttorneyCollectivelyByTwo, SkribblePowerOfAttorneyTwoSignatories, SkribblePowerOfAttorneyOneSignatory,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      debtorSumSub: null,
      debtorCompany: null,
      debtorEmail: '',
      status: '',
      sideImg: require('@/assets/images/pages/login-v5.png'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      disableInputs: false,
      language: 'en',
      formType: 'debt_ack_non_recourse',
      debtorData: {},
      loading: false,
      error: '',
      isCompleted: false,
      showBlueBorder: true,
      showPopup: false,
      invalidFields: {},
      form: {
        sign_salutation: '',
        sign_first: '',
        sign_last: '',
        sign_address: '',
        sign_zip: '',
        sign_city: '',
        sign_country: '',
        sign_mobile: '',
        sign_phone_code: 'CH',
        debtor_email: '',
      },
      countries: [],
      phoneValidation: '',
      countryOptions: [],
      signing_authority_type: '',
      signing_authority_type_values: ['Sole signatory', 'Collectively by two'],
      choose_signing_authority_type: null,
      phoneSignatorValidation: '',
      emailValidationsError: '',
      resLoader: false,

      signing_authority_type_error: null,
      choose_signing_authority_type_error: null,
      showButton:false,
      accept_checked_iframe: false,
      accept_checked_iframe_error: null,
      documentSigned: false,
      pollInterval: null,
      pollIntervalUserCheck: null,
      invoice: {
        only_seller: {}
      },
      locales: [
        {
          locale: 'en',
          img: '/images/flags/en.png',
          name: 'english',
        },

        {
          locale: 'de',
          img: '/images/flags/german.png',
          name: 'german',
        },
      ],
      hasHash: false,
      resMessage: '',
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v5.png')
        return this.sideImg
      }
      return this.sideImg
    },
    currentLocale() {
      let obj = null
      if (this.$i18n.locale) {
        if (this.$i18n.locale == 'en') {
          obj = {
            locale: 'en',
            img: '/images/flags/en.png',
            name: 'english',
          }
        } else {
          obj = {
            locale: 'de',
            img: '/images/flags/german.png',
            name: 'german',
          }
        }
      } else {
        obj = {
          locale: 'en',
          img: '/images/flags/en.png',
          name: 'english',
        }
      }
      this.$store.commit('app/UPDATE_LANGUAGE', obj.locale)
      return obj
    },
  },
  created() {
    if (this.$route.params.hash) {
      this.hasHash = true
      this.getDebtorId()
      this.confirmInvoice()
      this.getInvoice()
      this.fetchCountries();
      this.loadCountriesForPhone();
    }
  },

  methods: {

    loadCountriesForPhone() {
      this.$http.post('/countries').then(res => {
        res.data.value.map(item => {
          this.countries.push({
            value: item.iso_code,
            text: `${item.iso_code} (${item.phone_code})`,
          })
        })
      })
    },

    checkPhoneFormat() {
      const validation = phone(this.form.sign_mobile, {
        country: this.form.sign_phone_code,
        validateMobilePrefix: false,
      })

      if (validation && validation.isValid == false) {
        this.phoneValidation = `Phone for ${this.form.sign_phone_code} must be valid`
      } else {
        this.phoneValidation = ''
      }
    },

    fetchCountries() {
      this.$http.post('/countries').then(res => {
        const countries = res.data.value || [];

        // Filter out duplicates based on country.id
        const uniqueCountries = countries.filter(
            (country, index, self) =>
                index === self.findIndex(c => c.id === country.id)
        );

        this.countryOptions = uniqueCountries;
      });
    },

    getDebtorId() {
      this.$http.post('/getDebtor', {
        invoice_number: this.$route.params.hash,
      }).then(res => {
        const data = res.data?.value;

        if (data) {
          this.debtorCompany = data.company;
          this.debtorSumSub = data.debtor;

          if (this.debtorSumSub?.id) {
            this.getData(this.debtorSumSub.id);
          }
          this.refreshUser();
        }
      }).catch(err => {
        console.error("Error fetching debtor:", err);
      });
    },

    getFormType(form_type_id) {
      this.$http.post(`/skribble/get-form-type/${form_type_id}`).then((res) => {
        this.formType = res.data?.value?.form_type ?? '';
        this.checkSigningStatus(this.formType)
      });
    },

    getInvoice() {
      this.$http.post('/getInvoiceByHash', {
        invoice_number: this.$route.params.hash,
      }).then(async res => {
        if (res.data) {
          this.invoice = res.data.value;

          this.getFormType(this.invoice.id);

          const issue_date = new Date(this.invoice.issue_date);
          const due_date = new Date(this.invoice.due_date);
          const options = {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          };

          let iban = await this.getIbanWithCurrency(this.invoice.currency?.id);

          const formattedIssueDate = issue_date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
          const formattedDueDate = due_date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
          const invoice_type = this.invoice.is_reverse === 1 ? "reverse" : this.invoice.recourse === 1 ? "recourse" : "non-recourse";

          this.debtorData = {
            seller_company_id: this.invoice.only_seller?.id ?? '',
            seller_company_name: this.invoice.only_seller?.name ?? '',
            seller_address_zip: this.invoice.only_seller?.zip ?? '',
            seller_address_city: this.invoice.only_seller?.city ?? '',
            seller_address_country: this.invoice.only_seller?.country_name ?? '',
            seller_address_street: `${this.invoice.only_seller?.address ?? ''} ${this.invoice.only_seller?.address_nr ?? ''}`.trim(),

            invoice_id: this.invoice.id,
            invoice_number: this.invoice.invoice_number,
            invoice_amount: this.amountFormatCurrency(this.invoice.amount, this.invoice.currency?.name, 'type'),
            invoice_currency: this.invoice.currency?.name ?? '',
            invoice_type: invoice_type,
            due_date: formattedDueDate,
            issue_date: formattedIssueDate,
            iban: iban ?? '',
            form_type: this.formType ?? null,

            debtor_company_id: this.debtorCompany?.id ?? this.debtorSumSub?.company?.id ?? '',
            debtor_user_id: this.debtorSumSub?.id ?? '',
            debtor_company_name: this.debtorSumSub?.company?.name?.trim() ? this.debtorSumSub.company.name : this.debtorCompany?.name || '',
            debtor_uid: this.debtorCompany?.uid ?? this.debtorSumSub?.company?.uid ?? '',
            seller_uid: this.invoice.only_seller?.uid ?? '',
            debtor_address_zip: this.debtorSumSub?.company?.zip?.trim() ? this.debtorSumSub.company.zip : this.debtorCompany?.zip || '',
            debtor_address_city: this.debtorSumSub?.company?.city?.trim() ? this.debtorSumSub.company.city : this.debtorCompany?.city || '',
            debtor_address_country: this.debtorSumSub?.company?.country_name?.trim() ? this.debtorSumSub.company.country_name : this.debtorCompany?.country_name || '',
            debtor_address_street: `${this.debtorSumSub?.company?.address?.trim() ? this.debtorSumSub.company.address : this.debtorCompany?.address || ''} ${this.debtorSumSub?.company?.address_nr?.toString().trim() ? this.debtorSumSub.company.address_nr : this.debtorCompany?.address_nr || ''}`.trim(),
            debtor_f_name: this.debtorSumSub?.name?.trim() ? this.debtorSumSub.name : this.debtorCompany?.first_name || '',
            debtor_l_name: this.debtorSumSub?.last_name?.trim() ? this.debtorSumSub.last_name : this.debtorCompany?.last_name || '',

            company_address_country: this.debtorSumSub?.company?.country_name ?? this.debtorCompany?.country_name ?? '',
            language: this.$i18n.locale ?? 'de',
          };
        }
      })
    },

    async getIbanWithCurrency(currency_id) {
      try {
        const { data } = await this.$http.post(`/currency/get-iban-with-currency/${currency_id}`);
        if (data && data.value) {
          return data.value;
        }
      } catch (err) {
        console.error("Failed to get iban:", err);
        return null;
      }
    },

    amountFormatCurrency(amount, currency, type) {
      return CurrencyAmountFormat(amount, currency, type)
    },

    async refreshUser() {
      try {
        if (!this.debtorSumSub || !this.debtorSumSub.id) {
          console.warn("No debtor user available to refresh");
          this.$store.commit("auth/SET_USER", null);
          return this.$store.state.auth.user;
        }

        const { data } = await this.$http.post(`/getUserDataWithId/${this.debtorSumSub.id}`);

        if (data && data.value) {
          this.$store.commit("auth/SET_USER", data.value);
          return data.value;
        } else {
          console.warn("No user returned from backend");
          return this.debtorSumSub;
        }
      } catch (err) {
        console.error("Failed to refresh user:", err);
        return this.$store.state.auth.user;
      }
    },

    async saveInternalData() {
      try {
        this.resLoader = true
        const formSubmissionData = {
          main_contact_id: this.debtorSumSub.id,
          main_contact_signing_authority_type: this.signing_authority_type,
          main_contact_signing_authority_type_count: this.choose_signing_authority_type,
        }

        await this.$http.post('/company/store-debtor-main-contact', formSubmissionData)

      } catch (error) {
        console.error('Error:', error)
        this.resLoader = false
      } finally {
        this.resLoader = false
      }
    },

    async generateGermanDebtAcknowledgement() {
      this.disableSell = true;
      this.invalidFields = {};
      this.error = null;

      let required = [
          "sign_salutation", "sign_first", "sign_last", "debtor_email", "sign_address", "sign_zip", "sign_city", "sign_country", 'sign_phone_code', 'sign_mobile'
      ];

      required.forEach(field => {
        if (!this.form[field]) this.invalidFields[field] = true;
      });

      if (Object.keys(this.invalidFields).length) {
        this.error = this.$t("skr_error_fill_required");
        const firstInvalidField = Object.keys(this.invalidFields)[0];
        const el = this.$refs[firstInvalidField];
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          if (el.focus) el.focus();
        }
        return;
      }

      this.debtorData = {
        ...this.debtorData,
        sign_salutation: this.form.sign_salutation,
        sign_first: this.form.sign_first,
        sign_last: this.form.sign_last,
        sign_address: this.form.sign_address,
        sign_zip: this.form.sign_zip,
        sign_city: this.form.sign_city,
        sign_country: this.form.sign_country,
        sign_phone_code: this.form.sign_phone_code,
        sign_mobile: this.form.sign_mobile,
        debtor_email: this.form.debtor_email
      };

      this.debtorData.language = this.$i18n.locale ?? 'de';

      try {
        const res = await this.$http.post('/skribble/debt-acknowledgement/generate-debtor-pdf', this.debtorData);
        this.pdfUrl = res.data.value.pdf_url;
        if (this.pdfUrl) {
          this.handleButtonClick();
        }
      } catch (err) {
        console.error("Error generating PDF:", err);
      }
    },

    handlePopupConfirm() {
      this.showPopup = false;
      this.openSigningUrl();
    },

    handleButtonClick() {
      if (localStorage.getItem("hideSkribblePopup") === "true") {
        this.openSigningUrl();
      } else {
        this.showPopup = true;
      }
    },

    openSigningUrl() {
      let form_type = this.formType;

      this.saveInternalData();
      this.$http.post('/skribble/debt-acknowledgement/send-for-signing', this.debtorData).then((res) => {
        this.signingUrl = res.data.value.signing_url ?? null;

        if (this.signingUrl) {
          window.open(this.signingUrl, "_blank");
          this.pollInterval = setInterval(() => {
            this.checkSigningStatus(form_type)
          }, 10000);
        }
      })
    },

    checkSigningStatus(form_type) {
      const user = this.$store.state.auth.user;
      const invoice_id = this.invoice?.id ?? null;
      let payload = {
        invoice_id
      }

      let endpoint = '';

      if (this.debtorCompany) {
          endpoint = `/skribble/check-status/${this.debtorCompany.id}/${form_type}`;
          payload.is_company = true
      } else {
        endpoint = `/skribble/check-status/${user.id}/${form_type}`;
      }

      this.$http.post(endpoint, payload)
      .then((res) => {
        if (res.data?.value === "SIGNED") {
          clearInterval(this.pollInterval);
          this.pollInterval = null;
          this.documentSigned = true;
        }
      })
      .catch((err) => {
        console.error("Error checking signing status", err);
      });
    },

    getData(id) {
      this.$http.post(`/company/get-debtor-main-contact/${id}`).then(res => {
        if (res) {
          if (res.data.status == 200) {
            const data = res.data.value

            this.signing_authority_type = data.signing_authority_type ?? '';
            this.choose_signing_authority_type = data.signing_authority_type_count ?? '';

            if (this.signing_authority_type != 2) {
              this.choose_signing_authority_type = null
            }
          }
        }
      })
    },

    confirmInvoice() {
      const hash = this.$route.params.hash
      if (!hash) return

      this.$http.post(`/confirm/invoice/${hash}`)
      .then(response => {
        if (response.data && response.data.status === 200) {
          console.log('Invoice confirmed')
        } else {
          console.warn('Invoice confirmation failed')
        }
      })
      .catch(error => {
        console.error('Error confirming invoice:', error)
      })
    },

    completeIdentification() {
      this.choiceConfirmed = true
      this.showLoader = true
      // if (this.displayCompany) {
      //   this.levelName = 'institutional-investor/buyer'
      // } else if (!this.displayCompany) {
      //   this.levelName = 'individual-investors'
      // }
      this.levelName = 'Debtor'
      this.$http.post('/getSumsubClientId', {
        role: this.levelName,
        invoice_number: this.$route.params.hash,
      }).then(res => {
        if (res.data) {
          this.sumsubUserId = res.data.value.clientId
          setTimeout(() => {
            this.$http.post(`/sumsub/token?user_id=${this.debtorSumSub.id}&sumsub_id=${this.sumsubUserId}&level=${this.levelName}`).then(res => {
              if (res.data) {
                this.sumsubToken = res.data.token
                console.log(this.sumsubToken)
                // this.launchWebSdk(this.sumsubToken, this.$store.state.auth.user.email, this.$store.state.auth.user.tel);
                this.launchWebSdk()
              }
            })
          }, 2000)
        }
      })
    },
    // launchWebSdk(accessToken, applicantEmail, applicantPhone) {
    //   accessToken = this.sumsubToken
    //   const snsWebSdkInstance = snsWebSdk.init(
    //     accessToken,
    //     () => this.getNewAccessToken(),
    //   )
    //     .withConf({
    //       lang: 'en',
    //       email: applicantEmail,
    //       phone: applicantPhone,
    //       // externalUserId: `Prod-${this.$store.state.auth.user.id}`,
    //       // id: this.sumsubUserId
    //     })
    //     .withOptions({ addViewportTag: false, adaptIframeHeight: true })
    //     .on('idCheck.onStepCompleted', payload => {
    //       console.log('onStepCompleted', payload)
    //     })
    //     .on('idCheck.onError', error => {
    //       console.log('onError', error)
    //     })
    //     .build()
    //   snsWebSdkInstance.launch('#sumsub-websdk-container')
    //   this.showLoader = false
    // },

    toAequitex() {
      window.location = 'https://www.aequitex.com/'
    },
    toggleLanguage(language) {
      this.$i18n.locale = language
      this.language = language
      this.$store.commit('app/UPDATE_LANGUAGE', language)
    },
    goToLink() {
      window.location = 'http://marketing.aequitex.com/CH-EN/aequitex-pre-register-campaign-website'
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.header_block_div > a, .header_block_div > div {
  width: 10%;
}

.form_block {
  background-color: white;
  width: 100%;
  border-radius: 25px;
  overflow: hidden;
  height: fit-content;
  /*margin-top: 160px*/
}

.form_block .form_block_header {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #555;
  padding: 20px;
}

.form_block .form_block_header h2, .form_block .form_block_header span {
  color: #222f28;
}

.form_block input, .form_block select {
  background-color: #F7F6F4;
}

.form_block button {
  background-color: #577264 !important;
}

.modal_section {
  width: 98%;
  min-height: 150px;
  height: auto;
  padding: 20px 10px 20px 20px;
  font-weight: 500;
}

.modal_section:first-of-type {
  border-bottom: 1px solid #ccc;
}

.custom_modal .modal-dialog {
  max-width: 1200px !important;
}

.modal_section li {
  margin: 15px 0;
}

.register_section_buttons p {
  margin: 15px 0;
  font-size: 16px;
}

.large_screen_lang {
  display: block;
}

@media screen and (max-width: 992px) {
  .register_section_buttons {
    margin-top: 25px;
    padding: 0 40px !important;
  }

  .small_screen_lang {
    display: block;
    margin: 25px 0;
    text-align: right !important;
  }

  .large_screen_lang {
    display: none;
  }
}

</style>
<style scoped>

.skribble-container {
  margin: 0 auto;
  min-height: 800px;
  background: #e1e1e12e;
  padding: 35px !important;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
}

.skribble-container .skribble-form-poa-collectively-by-two,
.skribble-container .skribble-form-poa-one,
.skribble-container .skribble-form-poa-two {
  box-shadow: none;
  background: transparent;
  padding: 0 !important;
}

.main_block {
  width: 2100px;
  max-width: 2100px;
  margin: 0 auto;
}

.reg-content-section {
  width: 100%;
  height: 100%;
  display: flex;
  /*flex-direction: column;*/
}

.reg-content-section > div {
  width: 33%;
  height: 100%;
  display: flex;
  align-items: center;
}

.header_block_div {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  background-color: #F7F6F4
}

.brand-logo {
  position: unset !important;
}

.reg_logo_section {
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reg-lang-section {
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

iframe {
  margin-top: 150px;
}

@media screen and (max-width: 1250px) {

  .header_block_div > div {
    width: 50%;
  }

  .reg-content-section {
    flex-direction: column;
  }

  .reg-content-section > div {
    width: 100%;
    justify-content: center;
  }

  .register_section_buttons {
    margin: 0 !important;
  }

  .register_section_buttons ul {
    margin: 0 auto;
  }

  .form_block {
    width: 50%;
  }

  iframe {
    width: 50%;
  }
}

@media screen and (max-width: 800px) {
  .form_block {
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }

  iframe {
    margin-top: 40px;
    width: 100%;
  }

  .register_section_buttons h1 {
    font-size: 22px;
  }

  .register_section_buttons p {
    font-size: 14px;
  }
}

</style>
